import { IEvent } from "@quest/adapter-interface";
import { BottomBarView } from "@quest/murka-games-behavior-leopard/dist"
import { detectDeviceEnvironmentConstants ,dispatcher,ingenuity} from "@quest/base-core";
import { gameConstants } from "../Constants/gameConstants";
import { EventConstantsLeander } from "@quest/oddsworks-platform";



export class BottomBarViewGame extends BottomBarView {
    
    protected defaultFontSize: number = 18;

    public resize(e?: IEvent): void {
        super.resize(e);
        this.manageLandscapeGameLogo()
    }
    /**
     * to manage landscape top logo
     */
    public manageLandscapeGameLogo():void{
        const gameLogo = document.getElementById("landscape-logo");
        if(!ingenuity.deviceEnv.isDesktop && ingenuity.configData.isTopLogoVisible &&
            ingenuity.deviceEnv.getOrientation() !== detectDeviceEnvironmentConstants.constants.ORIENTATION.PORTRAIT){
            gameLogo.style.display = gameConstants.DISPLAY_BLOCK;
        }else{
            gameLogo.style.display = gameConstants.DISPLAY_NONE;
        }
    }
    // Overrided to update total win value on emulator
    public setWinValue(value: string, isValueInCredit: boolean): void {
      super.setWinValue(value, isValueInCredit);
      dispatcher.fireEvent(EventConstantsLeander.TOTAL_WIN_UPDATED, { winAmount: value === "0" ? value : Number(value).toFixed(2) });
    }
}
